import queryString from 'query-string'
import { v3RegistrationUrl } from '@theme'

// v2 is replaced by propell-web-v3. Only these public pages (and the mobile app webviews)
// stay open; everything else redirects unless the tab was opened with ?admin=true.
// Patterns match the same paths as their <Route> in Apps/index.js (exact or not)
const PUBLIC_PATHS = [
  /^\/locations\/[^/]+\/orders\/[^/]+\/pay(\/|$)/i,
  /^\/zipLandingPage(\/|$)/i,
  /^\/users\/reset-password\/?$/i,
  /^\/users\/confirm\/?$/i,
  /^\/follow-invite\/?$/i,
  /^\/version(\/|$)/i,
]

// sessionStorage, because logout() clears localStorage
const ADMIN_FLAG_KEY = 'v2Admin'

const shouldRedirectToV3 = ({ pathname, search }) => {
  const query = queryString.parse(search)
  if (query.admin === 'true') sessionStorage.setItem(ADMIN_FLAG_KEY, 'true')
  if (query.admin === 'false') sessionStorage.removeItem(ADMIN_FLAG_KEY)

  if (sessionStorage.getItem(ADMIN_FLAG_KEY) === 'true') return false
  if (query.mobileWebView) return false
  return !PUBLIC_PATHS.some(path => path.test(pathname))
}

// Carry ?token= over so a login-as link (/?token=...) signs the user in on v3 too
export const v3RedirectUrl = ({ search }) => {
  const { token } = queryString.parse(search)
  return token ? `${v3RegistrationUrl}?${queryString.stringify({ token })}` : v3RegistrationUrl
}

export default shouldRedirectToV3
